const _import = require("@/libs/util.import." + process.env.NODE_ENV)
export const routerName = {
  910: {
    path: "/rightsAndInterestsManage",
    name: "rightsAndInterestsManage",
    meta: {
      title: "权益配置",
      authId: "910",
      parentId: "1",
      cache: false
    }
  },
  91001: {
    path: "/ruleConfigurationList",
    name: "ruleConfigurationList",
    meta: {
      title: "规则配置",
      authId: "91001",
      parentId: "910",
      cache: false
    },
    auth: [
      {
        authId: "9100101",
        parentId: "91001",
        label: "查看",
        handle: "handleDetail",
        ruleObj: {
          attr: "status",
          rule: {
            0: "查看",
            1: "查看"
          },
          disabledStatusList: [0]
        }
      },
      {
        authId: "9100102",
        parentId: "91001",
        label: "编辑",
        handle: "handleEdit",
        ruleObj: {
          attr: "status",
          rule: {
            0: "待配置",
            1: "编辑"
          }
          // disabledStatusList: [0]
        }
      },
      {
        authId: "9100103",
        parentId: "91001",
        label: "新增",
        icon: "plus",
        category: "Button",
        type: "primary",
        handle: "handleAdd"
      },
      {
        authId: "9100104",
        parentId: "91001",
        label: "批量开通非融合",
        category: "Button",
        type: "primary",
        handle: "massDevelopmentNonFusion"
      },{
        authId: "9100105",
        parentId: "91001",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
    ],
    component: _import("rightsAndInterestsManage/ruleConfigurationList")
  }
}
